import script from "./CalendarDay.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarDay.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarDay.vue?vue&type=style&index=0&id=80fd9032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80fd9032"]])

export default __exports__